'use client'

import React, { useEffect, useState } from 'react'

import PageTransition from '@/page-transition/PageTransition'

export default function Template({ children }: { children: React.ReactNode }) {
    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
        setIsReady(true)
    }, [])

    return (
        <>
            {children}
            {isReady ? <PageTransition /> : <div className='h-blank' />}
        </>
    )
}